/* ==========================================================================
   KINOVA — SUZUVCHI TUGMALAR (15-bosqich)
   ==========================================================================
   HAR BIR ommaviy sahifada (bosh sahifa, kinolar, qidiruv, pleer, profil,
   ...) o'ng pastda ikkita tugma turadi:

     1. QO'LLAB-QUVVATLASH — bosilganda murojaat formasi (modal) ochiladi.
        Yuborilgan murojaat ADMIN PANELGA tushadi ("Aloqa xabarlari"
        bo'limi) — mavjud `POST /aloqa` endpoint'i va `contact_messages`
        jadvali qayta ishlatiladi, ikkinchi nusxa mantiq YARATILMAYDI.
        Foydalanuvchi turgan sahifasidan KETMAYDI (AJAX + JSON javob).

     2. TEPAGA — sahifa pastga siljitilganda paydo bo'ladi, bosilganda
        eng tepaga (sarlavha/menyu ko'rinadigan joyga) qaytaradi.
        Sahifaning eng tagida bo'lsa ham ishlaydi.

   ⚠️ NIMA UCHUN ALOHIDA FAYL: `main.js`/`components.js`/`icons.js` dizayn
      manbasidan bayt-bayt ajratilgan fayllar (`scripts/extract-assets.mjs`
      qo'riqlaydi). Bu modul mustaqil — `app.js` zanjirining oxirida
      import qilinadi va o'zini o'zi `<body>`ga joylaydi. Shu sababli
      biror sahifa shablonini o'zgartirish kerak emas: tugmalar
      AVTOMATIK barcha ommaviy sahifada paydo bo'ladi.

   ⚠️ Yangi rang/token YO'Q — barcha qiymatlar `tokens.css`dan
      (resources/css/support.css).

   ⚠️ ADMIN panelda ko'rinmaydi: admin bundle `app.js`ni import qilmaydi
      (`resources/js/admin.js` alohida zanjir) — shuning uchun qo'shimcha
      shart kerak emas.
   ========================================================================== */
(function (global) {
  'use strict';

  var SUPPORT_SUBJECT = "Qo'llab-quvvatlash so'rovi";

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function icon(name, size) {
    var Icon = global.Icon || {};
    var fn = Icon[name] || Icon.tag;

    return typeof fn === 'function' ? fn(size || 20) : '';
  }

  /* ── 17-bosqich: suzuvchi tugmalar uchun MAXSUS belgilar ───────────
     ⚠️ `icons.js` dizayn manbasidan bayt-bayt ajratilgan (o'zgartirib
        bo'lmaydi), shuning uchun bu ikki belgi shu yerda chiziladi.
        Ikkalasi ham 24×24 viewBox ichida SIMMETRIK — tugma o'rtasida
        aynan markazda turadi (avvalgi `message`/`chevronUp` belgilari
        vizual markazdan siljigan edi, foydalanuvchi shuni bildirgan). */

  /** Qo'llab-quvvatlash — garnitura (operator) belgisi. */
  function headsetIcon(size) {
    var s = size || 22;

    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' +
      '<path d="M4 13.5V12a8 8 0 0 1 16 0v1.5"/>' +
      '<rect x="2" y="13" width="4.6" height="7" rx="2.3"/>' +
      '<rect x="17.4" y="13" width="4.6" height="7" rx="2.3"/>' +
      '<path d="M19.7 20v.4a2.6 2.6 0 0 1-2.6 2.6H14"/>' +
      '</svg>';
  }

  /** Yuborish — qog'oz samolyot (icons.js da `send` yo'q). */
  function sendIcon(size) {
    var s = size || 17;

    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' +
      '<path d="M21 3 10.5 13.5"/>' +
      '<path d="M21 3l-6.8 18-3.7-7.5L3 9.8 21 3z"/>' +
      '</svg>';
  }

  /** Tepaga — qalin, aniq strelka. */
  function arrowUpIcon(size) {
    var s = size || 22;

    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' +
      '<path d="M12 19.5V5.5"/>' +
      '<path d="M5.2 12.3 12 5.5l6.8 6.8"/>' +
      '</svg>';
  }

  function esc(v) {
    return String(v === null || v === undefined ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function currentUser() {
    var D = global.KDATA || {};

    return D.CURRENT_USER || null;
  }

  /* ⚠️ CSRF token sayt bo'ylab `window.KINOVA_CSRF_TOKEN` orqali
     beriladi (layouts/app.blade.php) — YANGI <meta> tegi ATAYLAB
     qo'shilmaydi: `partials/head.blade.php` dizayn manbasidan
     bayt-bayt ko'zgulanadi va yangi meta teg vizual/DOM tenglik
     tekshiruvini buzardi. Pleerdagi `watch-progress` fetch'i ham
     aynan shu global'ni ishlatadi. */
  function csrfToken() {
    return global.KINOVA_CSRF_TOKEN || '';
  }

  /* ── Markup ──────────────────────────────────────────────────────── */

  /**
   * 16-bosqich: suzuvchi tugmalar + ikki bo'limli oyna.
   *
   *   • "Yangi murojaat" — forma (mehmon uchun ham).
   *   • "Murojaatlarim"  — FAQAT tizimga kirganlar uchun: har bir
   *     murojaat ALOHIDA yozuv (1 xabar = 1 yozuv) va administrator
   *     javobi shu yozuv ichida ko'rinadi. Mehmonda hisob yo'q, demak
   *     ro'yxat ham yo'q — bo'lim umuman chiqarilmaydi (soxta bo'sh
   *     bo'lim bo'lmasin).
   */
  function widgetHTML() {
    var user = currentUser();
    var unread = (user && Number(user.supportUnread)) || 0;

    var tabs = user
      ? '<div class="support-tabs" role="tablist">' +
        '<button type="button" class="support-tabs__btn is-active" id="supportTabNew" role="tab" aria-selected="true">Yangi murojaat</button>' +
        '<button type="button" class="support-tabs__btn" id="supportTabList" role="tab" aria-selected="false">' +
        'Murojaatlarim' +
        '<span class="support-tabs__count" id="supportTabCount"' + (unread ? '' : ' hidden') + '>' + unread + '</span>' +
        '</button>' +
        '</div>'
      : '';

    var listPane = user
      ? '<div class="support-pane" id="supportPaneList" hidden>' +
        '<div class="support-list" id="supportList"></div>' +
        '</div>'
      : '';

    return '' +
      '<div class="support-fab" id="supportFab">' +

      '<button type="button" class="support-fab__btn support-fab__btn--help" id="supportOpen"' +
      ' aria-label="Qo\'llab-quvvatlash">' +
      '<span class="support-fab__icon">' + headsetIcon(23) + '</span>' +
      '<span class="support-fab__badge" id="supportBadge"' + (unread ? '' : ' hidden') + '>' + unread + '</span>' +
      '<span class="support-fab__label">Qo\'llab-quvvatlash</span>' +
      '</button>' +

      '<button type="button" class="support-fab__btn support-fab__btn--top" id="supportToTop"' +
      ' aria-label="Tepaga" hidden>' +
      '<span class="support-fab__icon">' + arrowUpIcon(22) + '</span>' +
      '<span class="support-fab__label">Tepaga</span>' +
      '</button>' +

      '</div>' +

      '<div class="modal-overlay" id="supportOverlay" role="dialog" aria-modal="true" aria-labelledby="supportTitle">' +
      '<div class="modal support-modal">' +

      '<div class="support-modal__head">' +
      '<span class="support-modal__head-icon">' + headsetIcon(24) + '</span>' +
      '<div class="support-modal__head-text">' +
      '<h3 id="supportTitle">Qo\'llab-quvvatlash</h3>' +
      '<p>Savolingizga administrator javob beradi</p>' +
      '</div>' +
      '<button type="button" class="icon-btn support-modal__close" id="supportClose" aria-label="Yopish">' +
      icon('close', 18) + '</button>' +
      '</div>' +

      tabs +

      '<div class="support-pane" id="supportPaneNew">' +
      '<form id="supportForm" novalidate>' +
      '<div class="support-form__grid">' +
      '<div class="field">' +
      '<label for="supportName">Ismingiz</label>' +
      '<input type="text" id="supportName" name="name" maxlength="100" required value="' +
      esc(user && user.name ? user.name : '') + '">' +
      '</div>' +
      '<div class="field">' +
      '<label for="supportEmail">Email' + (user ? ' (ixtiyoriy)' : '') + '</label>' +
      '<input type="email" id="supportEmail" name="email" maxlength="190"' + (user ? '' : ' required') +
      ' value="' + esc(user && user.email ? user.email : '') + '">' +
      '</div>' +
      '</div>' +
      '<p class="field-hint support-form__note">' + (user
        ? 'Javobni shu oynadagi "Murojaatlarim" bo\'limida ko\'rasiz.'
        : 'Javob shu email manzilga yuboriladi.') + '</p>' +
      '<div class="field">' +
      '<label for="supportMessage">Murojaat matni</label>' +
      '<textarea id="supportMessage" name="message" rows="6" maxlength="5000" required' +
      ' placeholder="Muammoni batafsil yozing: qaysi sahifada, nima qildingiz, nima bo\'ldi."></textarea>' +
      '</div>' +
      '<div class="support-modal__alert" id="supportAlert" hidden></div>' +
      '<button type="submit" class="btn btn--primary btn--lg btn--block support-form__submit" id="supportSubmit">' +
      sendIcon(17) + ' Yuborish</button>' +
      '</form>' +
      '</div>' +

      listPane +

      '</div>' +
      '</div>';
  }

  /**
   * Bitta murojaat yozuvi. "1 xabar = 1 yozuv" — guruhlash yo'q.
   * Javob bo'lmasa halol "javob kutilmoqda" deyiladi (soxta javob yo'q).
   */
  function messageItemHTML(m) {
    var reply = m.reply
      ? '<div class="support-item__reply' + (m.replyUnread ? ' is-unread' : '') + '">' +
        '<span class="support-item__reply-label">' + icon('message', 13) + ' Administrator javobi' +
        (m.answeredAt ? ' · ' + esc(m.answeredAt) : '') + '</span>' +
        '<p>' + esc(m.reply).replace(/\n/g, '<br>') + '</p>' +
        '</div>'
      : '<p class="support-item__pending">' + icon('clock', 13) + ' Javob kutilmoqda</p>';

    return '<article class="support-item' + (m.replyUnread ? ' support-item--unread' : '') + '">' +
      '<header class="support-item__head">' +
      '<h4>' + esc(m.subject) + '</h4>' +
      '<span class="status-dot status-dot--' + esc(m.statusTone) + '">' + esc(m.statusLabel) + '</span>' +
      '</header>' +
      '<p class="support-item__date">' + esc(m.createdAt || '') + '</p>' +
      '<p class="support-item__text">' + esc(m.message).replace(/\n/g, '<br>') + '</p>' +
      reply +
      '</article>';
  }

  /* ── Xatti-harakat ───────────────────────────────────────────────── */
  function wire() {
    var overlay = document.getElementById('supportOverlay');
    var openBtn = document.getElementById('supportOpen');
    var closeBtn = document.getElementById('supportClose');
    var toTop = document.getElementById('supportToTop');
    var form = document.getElementById('supportForm');
    var alertEl = document.getElementById('supportAlert');
    var submitBtn = document.getElementById('supportSubmit');
    var tabNew = document.getElementById('supportTabNew');
    var tabList = document.getElementById('supportTabList');
    var paneNew = document.getElementById('supportPaneNew');
    var paneList = document.getElementById('supportPaneList');
    var listEl = document.getElementById('supportList');
    var badge = document.getElementById('supportBadge');
    var tabCount = document.getElementById('supportTabCount');
    if (!overlay || !openBtn || !form) return;

    /* ── Belgi (badge) ──────────────────────────────────────────────
       O'qilmagan javoblar soni sahifa yuklanishida serverdan keladi
       (KdataBootstrapComposer → CURRENT_USER.supportUnread). Ro'yxat
       ochilgach server ularni "o'qilgan" deb belgilaydi, shuning uchun
       bu yerda ham nolga tushiriladi — qo'shimcha so'rov shart emas. */
    function setUnread(n) {
      var show = Number(n) > 0;
      [badge, tabCount].forEach(function (el) {
        if (!el) return;
        el.textContent = String(n);
        el.hidden = !show;
      });
    }

    /* ── Murojaatlarim ro'yxati ─────────────────────────────────────
       Har bir murojaat ALOHIDA yozuv (1 xabar = 1 yozuv). Ro'yxat
       oyna ochilganda bir marta olinadi va yangi murojaat
       yuborilgandan keyin yangilanadi. */
    var listLoaded = false;

    function renderList(messages) {
      if (!listEl) return;

      if (!messages.length) {
        listEl.innerHTML = '<div class="support-list__empty">' + icon('message', 26) +
          '<p>Hali murojaat yubormagansiz.</p></div>';

        return;
      }

      listEl.innerHTML = messages.map(messageItemHTML).join('');
    }

    function loadList(force) {
      if (!listEl || (listLoaded && !force)) return;
      listEl.innerHTML = '<p class="support-list__loading">Yuklanmoqda…</p>';

      fetch('/murojaatlarim', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.ok) {
            listEl.innerHTML = '<p class="support-list__loading">Ro\'yxatni yuklab bo\'lmadi.</p>';

            return;
          }
          listLoaded = true;
          renderList(data.messages || []);
          setUnread(0); // server ham o'qilgan deb belgiladi
        })
        .catch(function () {
          listEl.innerHTML = '<p class="support-list__loading">Tarmoq xatosi.</p>';
        });
    }

    function activateTab(which) {
      if (!tabNew || !tabList) return;
      var isList = which === 'list';
      tabNew.classList.toggle('is-active', !isList);
      tabList.classList.toggle('is-active', isList);
      tabNew.setAttribute('aria-selected', String(!isList));
      tabList.setAttribute('aria-selected', String(isList));
      if (paneNew) paneNew.hidden = isList;
      if (paneList) paneList.hidden = !isList;
      if (isList) loadList(false);
    }

    if (tabNew) tabNew.addEventListener('click', function () { activateTab('new'); });
    if (tabList) tabList.addEventListener('click', function () { activateTab('list'); });

    function showAlert(text, kind) {
      alertEl.textContent = text;
      alertEl.className = 'support-modal__alert support-modal__alert--' + kind;
      alertEl.hidden = false;
    }
    function hideAlert() { alertEl.hidden = true; }

    function open() {
      overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');
      hideAlert();

      /* O'qilmagan javob bo'lsa DARHOL "Murojaatlarim" ochiladi —
         foydalanuvchi belgini (badge) ko'rib bosgan, demak javobni
         izlayapti. Aks holda odatiy "Yangi murojaat" bo'limi. */
      var u = currentUser();
      if (u && Number(u.supportUnread) > 0 && tabList) {
        activateTab('list');

        return;
      }

      if (tabNew) activateTab('new');
      var first = document.getElementById('supportName');
      if (first) setTimeout(function () { first.focus(); }, 120);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    /* ── "Tepaga" tugmasi ───────────────────────────────────────────
       ⚠️ Faqat `window.scrollTo` yetarli emas: ba'zi sahifalarda
          skroll `documentElement` da, ba'zilarida `body` da hisoblanadi
          (brauzer/rejimga qarab). Ikkalasi ham 0 ga qo'yiladi —
          shuning uchun sahifaning ENG TAGIDA bo'lsa ham tepaga
          qaytaradi. `scroll-behavior` CSS'da (support.css). */
    function scrollPos() {
      return global.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }
    function syncToTop() {
      if (!toTop) return;
      toTop.hidden = scrollPos() < 320;
    }
    if (toTop) {
      toTop.addEventListener('click', function () {
        try {
          global.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        } catch (err) {
          global.scrollTo(0, 0);
        }
        // Zaxira (eski brauzerlar / `behavior` qo'llanmasa).
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
      global.addEventListener('scroll', syncToTop, { passive: true });
      syncToTop();
    }

    /* ── Murojaatni yuborish ────────────────────────────────────────
       Mavjud `POST /aloqa` endpoint'i (PageController::submitContact)
       ishlatiladi — AJAX bo'lgani uchun JSON qaytadi va sahifa
       yangilanmaydi. Server validatsiyasi YAGONA haqiqat manbai:
       xatolar shu yerda ko'rsatiladi. */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideAlert();

      var payload = {
        name: (document.getElementById('supportName') || {}).value || '',
        email: (document.getElementById('supportEmail') || {}).value || '',
        subject: SUPPORT_SUBJECT,
        message: (document.getElementById('supportMessage') || {}).value || ''
      };

      /* ⚠️ `innerHTML` saqlanadi (textContent EMAS): tugma ichida
         qog'oz-samolyot belgisi bor — matnni almashtirsak belgi
         yo'qolib qolardi. */
      var submitHTML = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Yuborilmoqda…';

      /* Manzil `routes/web.php` dagi `contact.store` (`POST /aloqa`) —
         mavjud, validatsiyasi va throttle'i bor endpoint. */
      fetch('/aloqa', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': csrfToken()
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (body) { return { status: r.status, body: body }; });
        })
        .then(function (res) {
          if (res.status === 200 && res.body && res.body.ok) {
            form.reset();
            var u = currentUser();
            if (u) {
              document.getElementById('supportName').value = u.name || '';
              document.getElementById('supportEmail').value = u.email || '';
            }
            showAlert(res.body.message || 'Murojaatingiz yuborildi.', 'ok');
            // Yangi yozuv darhol "Murojaatlarim" ro'yxatida ko'rinsin.
            if (u) loadList(true);

            return;
          }

          if (res.status === 422 && res.body && res.body.errors) {
            var msgs = [];
            Object.keys(res.body.errors).forEach(function (k) {
              msgs = msgs.concat(res.body.errors[k]);
            });
            showAlert(msgs.join(' '), 'error');

            return;
          }

          if (res.status === 429) {
            showAlert('Juda ko\'p urinish. Bir daqiqadan keyin qayta yuboring.', 'error');

            return;
          }

          showAlert('Yuborilmadi. Birozdan keyin qayta urinib ko\'ring.', 'error');
        })
        .catch(function () {
          showAlert('Tarmoq xatosi. Internet aloqasini tekshirib, qayta yuboring.', 'error');
        })
        .then(function () {
          submitBtn.disabled = false;
          submitBtn.innerHTML = submitHTML;
        });
    });
  }

  ready(function () {
    // Faqat ommaviy sahifalar: admin qobig'i bo'lsa qo'shilmaydi.
    if (document.querySelector('.admin-shell')) return;
    if (document.getElementById('supportFab')) return; // ikki marta qo'shilmasin

    document.body.insertAdjacentHTML('beforeend', widgetHTML());
    wire();
  });
})(window);
